import React, { useEffect, useState } from "react";
import { Button, Col, Container, Offcanvas, Row } from "react-bootstrap";
import { Images } from "./Images";
import { NavLink } from "react-router-dom";
import Marquee from "react-fast-marquee";




const About = ({ cmsLits }) => {

  const [value1, setValue1] = useState()

  useEffect(() => {
    if (cmsLits) {
      setValue1(cmsLits.find((value) => (value.identifier == 'About Flashloan')))
    }
  }, [cmsLits]);

  return (
    <div className="about">
      {/* <div className="top_gradient"></div> */}
      <Container className="custom_container">
        <div className="aboutrow align-items-center">
          {/* <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 mb-5 mb-lg-0"> */}
          <div>
            <div className="header_sec">
              <p className="title-txt mb-0">
                {/* About the <span className="linear-txt">Flash Loan</span> */}
                {value1?.heading}
              </p>
              <img src={Images.aboutarrow} alt="About arrow" className="arrow_src img-fluid" />
            </div>
          </div>
          {/* <div className="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 mb-5 mb-lg-0"> */}
          <div>
            <div className="center_sec">
              <div className="header_sec">
                <p className="subTitle-txt mb-0 t-grey">
                  {value1?.content}
                </p>
              </div>
            </div>
          </div>
          {/* <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2"> */}
          <div>
            <div className="btn_sec">
              <div className="card_btn automatic">
                {/* <div className="mode">
                  <div className="icon">
                    <img src={Images.auto} className="img_src img-fluid" />
                  </div>
                  <p className="val mb-0">Automatic</p>
                </div> */}
                <Button className="get_staretedBtn cmn_blueBtn">
                  Automatic
                  {/* <img src={Images.rytArrow} className="arrow_src img-fluid" /> */}
                </Button>
              </div>
              <div className="card_btn manual">
                {/* <div className="mode">
                  <div className="icon">
                    <img src={Images.manual} className="img_src img-fluid" />
                  </div>
                  <p className="val mb-0">Manual</p>
                </div> */}
                <Button className="get_staretedBtn cmn_blueBtn outlinebtn">
                  Manual
                  {/* <img src={Images.rytArrow} className="arrow_src img-fluid" /> */}
                </Button>
              </div>
            </div>
          </div>
          {/* <div className="col-12 col-sm-12 col-md-5 col-lg-6 col-xl-6">
            <div className="ryt_imgSec">
              <img src={Images.aboutBg} className="img_src img-fluid" />
            </div>
          </div> */}
        </div>
      </Container>
    </div>
  );
};

export default About;
